<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="1000px"
      v-bind:body-style="{ height: '400px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="标题名称:" prop="title">
              <a-input v-model="searchList.title" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="编号:" prop="menuNo">
              <a-input v-model="searchList.menuNo" :allowClear="true" placeholder="请输入" :disabled="disabled"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="绑定商品:" prop="goodsName">
              <a-input v-model="searchList.goodsName" disabled >
                <a-icon type="ellipsis" slot="addonAfter" style="cursor: pointer;" @click="selectFn()"/>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="外部链接URL:" prop="urlAddress">
              <a-input v-model="searchList.urlAddress" :allowClear="true" placeholder="请输入" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="显示顺序:" prop="menuOrder">
              <a-input v-model="searchList.menuOrder" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="服务状态:" prop="status">
              <a-radio-group v-model="searchList.status">
                <a-radio :value="'01'">
                  启用
                </a-radio>
                <a-radio :value="'02'">
                  禁用
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item
              required
              label="配图"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 15 }"
            >
              <upload :downid="id" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>

    <!-- 表单 -->
    <selectModal
      v-if="selectVisible"
      :modalTitle="selectModalTitle"
      @close="close" 
      @handleOk="selectlHandleOk"
    ></selectModal>
  </div>
</template>

<script>
import upload from "@/components/upload/upload.vue";
import selectModal from "./select-modal.vue";
export default {
  components: {
    upload,
    selectModal
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "客户黑白名单",
    }, //标题
    data: {
      type: Object,
      default: () => {},
    },//返回信息
    addId: {
      type: String,
      default: () => "",
    },//id
  },
  data() {
    //自定义校验规则
    var checkNumber = (rule, value, callback) => {
      if (value) {
        if (value <= 0) {
          return callback(new Error('请输入大于0的数'));
        } else if (!Number.isInteger(Number(value))) {
          return callback(new Error('请输入整数'));
        } else if (Number(value) > 99999) {
          return callback(new Error('显示顺序不能超过5位数！'));
        }
      }
      return callback();
    };
    return {
      id: "",
      uploadAgain: false,
      fileNum: 0,
      
      visible: true,

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        id: this.addId,
        title: "",
        menuNo: "",
        goodsName: "",
        goodId:"",
        urlAddress: "/classify/orderDetail",
        imgUrl: "",
        status: "01",
        menuOrder:"",
      },

      //校验规则
      rules: {
        title: [
          {
            required: true,
            message: "标题名称不能为空！",
            trigger: "blur",
          },
          {
            max: 20,
            message: "不可超过20字",
            trigger: "blur",
          }
        ],
        menuNo: [
          {
            required: true,
            message: "编号不能为空！",
            trigger: "blur",
          },
          {
            max: 20,
            message: "不可超过20字",
            trigger: "blur",
          }
        ],
        goodsName: [
          {
            required: true,
            message: "绑定商品不能为空！",
            trigger: "blur",
          },
        ],
        urlAddress: [
          {
            required: true,
            message: "外部链接URL不能为空！",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "服务状态不能为空！",
            trigger: "blur",
          },
        ],
        menuOrder: [
          {
            required: true,
            message: "显示顺序不能为空！",
            trigger: "blur",
          },
          {
            validator: checkNumber,
            trigger: "change",
          },
        ],
      },

      //弹窗
      selectVisible: false,
      selectModalTitle: "",
      //编号显隐
      disabled:false,
      
    }
  },
  mounted() {
    if (this.modalTitle == "编辑") {
      console.log(this.data)
      this.searchList = this.data;
      this.id = this.data.pictList[0].busId;
      this.disabled = true;
      this.searchList.goodId = this.data.goodsId;
    } else {
      this.id = this.addId;
    }
    console.log("id",this.id)
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },
    //保存
    handleOk() {
      if (this.searchList.imgUrl == "" || this.searchList.imgUrl == null || this.searchList.imgUrl == undefined) {
        return this.$message.warning("请上传配图！")
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleOk",this.searchList,this.modalTitle); 
        }
      });
      // this.$emit("handleOk",this.data,this.searchList); 
    },
    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      if(val.length == 0){
        this.searchList.imgUrl ="";
      } else {
        this.searchList.imgUrl = val[0].id;
        this.uploadAgain = true;//监听是否已上传文件
      }
      this.fileNum = val.length;
    },
    //绑定商品
    selectFn() {
      this.selectVisible = true;
      this.selectModalTitle = "选择商品";
    },
    //关闭弹窗
    close() {
      this.selectVisible = false;
    },
    //弹窗确认
    selectlHandleOk(data) {
      this.searchList.goodsName = data[0].goodsName;
      this.searchList.goodId = data[0].id;
      this.selectVisible = false;
    },

  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
